<template>
<div>
    <Header />
    <div class="desktop">
        <BlackHeaderRight :headerText="headerText" :headerTextEmpahasis="headerTextEmpahasis" :subText="subText" :fadedText="fadedText" />
    </div>
    <div class="mobile">
        <BlackHeaderMobile :headerText="headerText" :headerTextEmpahasis="headerTextEmpahasis" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <BodyLinks />
    <div class="container">
        <Activation />
        <div class="text-center mb-5 ">
            <p class="main-text">Jop Openings</p>
        </div>
        <section class="text-center mb-5">

            <p class="sub-main-text">
                Thanks for checking our career page, No vacant position at this time … </p>
            <!-- <div class="mt-5 mb-5">
                <router-link to="/accounts/signup" class="btn btn-warning text-white">Join Us
                    <font-awesome-icon :icon="['fas', 'arrow-right']" />
                </router-link>
            </div> -->

        </section>

    </div>

    <Footer />

</div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import BlackHeaderRight from "@/components/BlackHeaderRight.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import Activation from "@/components/Activation.vue";

export default {
    name: "about-us",
    data: function () {
        return {
            headerText: "Begin your",
            headerTextEmpahasis: "Career",
            subText: "Find all the job vacancies",
            fadedText: "Careers"
        }
    },
    components: {
        Header,
        BlackHeaderRight,
        BlackHeaderMobile,
        BodyLinks,
        Activation,
        Footer,

    }
}
</script>

<style scoped>
.mb-5 {
    margin-bottom: 5rem !important
}

.culture-section {
    height: 660px;
    margin-top: 150px;
    background-image: url('../assets/images/cultural-image.png');
    background-repeat: no-repeat;
    background-position: right;
}

.culture-sec img {
    height: 43vh
}

.offset-black {
    height: 528px;
    width: 47%;
    background: #000;
    color: #fff;
    margin-top: -80px;
    position: absolute;
    padding: 80px
}

.cul-black-section {
    background: #000;
    width: 100%;
    padding: 1.5rem;
    color: #fff;
}

.cul-black-section p:first-child {
    color: #F7B131;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 24px;
    letter-spacing: -0.25px;
}

.offset-black p {
    font-size: 18px;
    line-height: 32px;
    text-justify: auto;
    letter-spacing: 0.25px;

}

.offset-black p:first-child {
    font-weight: 600;
    font-size: 26px;
    letter-spacing: -0.25px;
    text-transform: uppercase;
    color: #F7B131;
}

.btn-warning {
    padding: 10px 30px;
}

@media screen and (min-width: 1400px) {
    .culture-section {
        background-repeat: no-repeat;
        background-size: cover;
    }
}
</style>
